import React from 'react';
import '../NotFound/style.css';

const NoMatch = () => {
    return (
        <p>
            ¯\_(ツ)_/¯
            <br/>
            Uh oh. There is nothing here.
        </p>
    )
}

export default NoMatch;